/*
  VF printing network guard.

  Why this exists.

  vf-printing.js intercepts the add to cart click on document in the capture
  phase. That beats any handler bound to the button or the form, but it does
  NOT beat another document level capture listener that registered earlier,
  because listeners on the same node in the same phase fire in registration
  order. vf-printing.js is loaded with defer, so it registers at the very end
  of page load, after every app embed script in the head. Globo Pre-order,
  Orichi Bundle and Bundler are all enabled on this store and all bind to add
  to cart. Whenever one of them registers first it calls
  stopImmediatePropagation, our handler never runs, the add goes over the Cart
  API, and the file upload is silently dropped. That is a race we cannot win
  reliably, and losing it is what produced orders 21520, 21522 and 21529.

  So this file stops competing for the click. Whichever script handles the
  click, it still has to POST to /cart/add over fetch or XHR. This patches both
  and refuses that request while printing is switched on, running the native
  multipart post instead. Load order stops mattering.

  This must load WITHOUT defer and BEFORE vf-printing.js, so the patch is in
  place before anything can call the cart. It talks to the module only through
  the DOM and the module's public methods, so vf-printing.js needs no changes.

  Residual risk worth knowing: an app that saved its own reference to
  window.fetch before this file ran would bypass the fetch patch. The XHR patch
  is on the prototype, so that one holds regardless. The cart guard in
  vf-print-cart-note.liquid is the backstop for anything that still slips past.
*/

(function () {
  if (window.__vfPrintNetGuard) return;
  window.__vfPrintNetGuard = true;

  function isCartAdd(url) {
    try {
      return /\/cart\/add(\.js)?(\?|$)/.test(String(url));
    } catch (e) {
      return false;
    }
  }

  function isPost(method) {
    return String(method || 'GET').toUpperCase() === 'POST';
  }

  // setOn() puts .vf-print--on on the element, so the DOM already tells us
  // whether printing is switched on. No change to vf-printing.js needed.
  function activeModule() {
    var el = document.querySelector('vf-printing.vf-print--on');
    if (!el || typeof el.postNatively !== 'function') return null;
    return el.isActive ? el : null;
  }

  // Returns true when we have taken the add over and the caller's request
  // should not proceed.
  function takeOver() {
    var el = activeModule();
    if (!el) return false;

    // Our own native post is already running. Let it be.
    if (el.submitting) return false;

    if (el.blocked) {
      el.reportBlocked();
      return true;
    }

    el.postNatively();
    return true;
  }

  /* ---------- fetch ---------- */

  var nativeFetch = window.fetch;

  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = input && input.url ? input.url : input;
      var method = (init && init.method) || (input && input.method);

      if (isCartAdd(url) && isPost(method) && takeOver()) {
        // postNatively() calls form.submit(), so the page is navigating away.
        // A promise that never settles is correct here: resolving it would let
        // the app carry on and render a cart drawer for an add that is being
        // replaced. The document is being torn down either way.
        return new Promise(function () {});
      }

      return nativeFetch.apply(this, arguments);
    };
  }

  /* ---------- XMLHttpRequest ---------- */

  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__vfMethod = method;
    this.__vfUrl = url;
    return nativeOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (isCartAdd(this.__vfUrl) && isPost(this.__vfMethod) && takeOver()) {
      return;
    }
    return nativeSend.apply(this, arguments);
  };
})();
